import type {ItemLayouts} from '@wix/document-services-types'
import {isEmpty} from 'lodash'
import type {CalculateParams} from '../types'
import {convertYToPx} from '../converters/y'

export const calculateY = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.y(compRef) !== undefined) {
        return
    }

    const itemLayout = layoutData.itemLayout as ItemLayouts
    if (!itemLayout || isEmpty(itemLayout)) {
        set.y(compRef, 0)
        return
    }

    let y = 0

    switch (itemLayout.type) {
        case 'GridItemLayout':
        case 'FixedItemLayout': {
            y = convertYToPx.alignSelf({...calculateParams, value: itemLayout})
            break
        }
        case 'FlexItemLayout':
        case 'OrganizerItemLayout':
        case 'StackItemLayout':
        default: {
            y = 0
            break
        }
    }

    set.y(compRef, y)
}
